import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " Mise à jour de l'ordre de la ligne ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Ordre")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.parameters.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.parameters.visible) = $event)),
      closable: true,
      centered: true,
      "destroy-on-close": true,
      width: 450
    }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_row, { type: "flex" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              flex: "auto",
              align: "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  class: "btn-warning",
                  onClick: _ctx.close
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_popconfirm, {
                  title: "Êtes-vous sûr de vouloir mettre à jour l'ordre de la ligne ?",
                  "ok-text": "Oui",
                  "cancel-text": "Annuler",
                  onConfirm: _ctx.updateReference
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      "html-type": "submit",
                      disabled: _ctx.disabled
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Mettre à jour ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["onConfirm"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_space, { direction: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_alert, { type: "warning" }, {
              message: _withCtx(() => [
                _createTextVNode(" Vous pouvez choisir un ordre de " + _toDisplayString(_ctx.min) + " à " + _toDisplayString(_ctx.max) + ". ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { type: "flex" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, null, {
                      label: _withCtx(() => [
                        _hoisted_2
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_number, {
                          value: _ctx.parameters.reference,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parameters.reference) = $event)),
                          controls: false,
                          precision: 0,
                          min: _ctx.min,
                          max: _ctx.max
                        }, null, 8, ["value", "min", "max"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}